<div class="tw-relative">
  <ul class="tw-flex tw-justify-between">
    <!-- Steps divided into 5 major categories -->
    <li class="tw-w-4 tw-h-4 tw-z-20 tw-rounded-full" [ngClass]="p<=stepGroup ? 'tw-bg-yellow' : 'tw-bg-grayLight' "
      *ngFor="let p of [1,2,3,4,5]"></li>
  </ul>
  <div class="tw-w-full tw-bg-grayLight tw-h-1 tw-z-10 tw-top-1/3 tw-absolute">
    <div class="tw-bg-yellow tw-h-1 tw-z-10" [ngStyle]="{width: progress + '%'}"></div>
  </div>
</div>